import { ACTION, Box, Dialog, Stack, SubProductTypeEnum, Text, type useDisclosureWithContext } from '@talos/kyoko';

import { DealCard } from '@src/components/OMS/ManualDealTradeView/DealCard';
import { useRoleAuth } from '@src/hooks/useRoleAuth';
import type { OTCDealData } from '@src/types/OTC';
import { getOtcDealDisplayUser } from '@src/utils/OTC/otcDealDisplayUtils';
interface ModifyDealWarningDialogProps {
  disclosure: ReturnType<typeof useDisclosureWithContext<OTCDealData>>;
  handleConfirm: (deal: OTCDealData) => void;
}

export const ModifyDealWarningDialog = ({ disclosure, handleConfirm }: ModifyDealWarningDialogProps) => {
  const { isAuthorized } = useRoleAuth();

  return (
    <Dialog
      {...disclosure}
      width={450}
      onConfirm={() => {
        disclosure.context && handleConfirm(disclosure.context);
      }}
      confirmLabel="Modify Deal"
      cancelLabel="Return"
      data-testid="modify-warning-dialog"
      confirmDisabled={!isAuthorized(ACTION.SUBMIT_DEAL)}
      title="Modify Confirmation"
    >
      {disclosure.context && <ModifyDealWarningDialogContent selectedDeal={disclosure.context} />}
    </Dialog>
  );
};

const ModifyDealWarningDialogContent = ({ selectedDeal }: { selectedDeal: OTCDealData }) => {
  let dealDisplayType: 'Deal' | 'Loan' | 'Repo' = 'Deal';
  switch (selectedDeal.SubProductType) {
    case SubProductTypeEnum.OTCFixedRateLoan:
    case SubProductTypeEnum.OTCFloatingRateLoan:
      dealDisplayType = 'Loan';
      break;
    case SubProductTypeEnum.OTCRepo:
      dealDisplayType = 'Repo';
      break;
  }
  return (
    <Stack gap="spacing12" alignItems="stretch">
      <Text textAlign="left" color="colorTextAttention">
        Are you sure you want to modify a {dealDisplayType.toLowerCase()} last modified by{' '}
        <b>{getOtcDealDisplayUser(selectedDeal) ?? '—'}</b>?{' '}
      </Text>
      <Box maxWidth="100%">
        <DealCard deal={selectedDeal} />
      </Box>
    </Stack>
  );
};
